import { graphClient } from '../graph-client'
import type { LiveCheckinLevel } from '../../types/check-in'
import type { Response } from '../../types/response'
import { GET_LIVE_CHECKIN_LEVELS } from './gql'

export namespace GetList {
  export interface Input {
    take?: number
    skip?: number
    active?: boolean
    deleted?: boolean
  }
  export interface Output {
    getLiveCheckinLevels: Response<LiveCheckinLevel[]>
  }
}

class LiveCheckinLevelsService {
  async getList(params: GetList.Input) {
    const res = await graphClient.request<GetList.Output>(
      GET_LIVE_CHECKIN_LEVELS,
      params,
    )
    return res?.getLiveCheckinLevels
  }
}

export const liveCheckinLevelsService = new LiveCheckinLevelsService()
